import "./index.scss";

export const RedIndicator = () => {
  return (
    <div className="red-indicator-wrapper">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="9"
        height="9"
        viewBox="0 0 9 9"
        fill="none"
      >
        <path
          d="M8.23107 4.49919C8.23107 6.74024 6.41434 8.55697 4.17329 8.55697C1.93224 8.55697 0.115508 6.74024 0.115508 4.49919C0.115508 2.25814 1.93224 0.441406 4.17329 0.441406C6.41434 0.441406 8.23107 2.25814 8.23107 4.49919Z"
          fill="#DC3545"
        />
      </svg>
    </div>
  );
};
